// Single source for purity naming — never a bare karat number. A lower karat
// reads as lesser to an Indian buyer unless framed as real, solid gold.
// Admin-tunable via settings.purity_labels (served on /store/config).
const DEFAULTS = {
  "9K": "9KT Solid Gold", "14K": "14KT Solid Gold",
  "18K": "18KT Solid Gold", "22K": "22KT Solid Gold",
  "925": "925 Sterling Silver",
};

export function purityLabel(purity, config) {
  const map = config?.purity_labels || {};
  return map[purity] || DEFAULTS[purity] || purity || "";
}

// PDP named purity variants: "9KT Yellow Gold", "18KT Rose Gold", "925 Sterling Silver".
export function colourVariantLabel(purity, colour, config) {
  if (purity === "925") return purityLabel("925", config);
  return `${purity || ""} ${colour || "Yellow"} Gold`.trim();
}

// Stone naming per metal — never describe cubic zirconia as diamond.
export function stoneLabel(metal) {
  return metal === "silver" ? "Cubic zirconia" : "Lab-grown diamond";
}
